import api from '@/services/api'

const state = {
  data: null,
  loading: false,
  lastCompanyId: null,
  lastFetchedAt: null
}

const mutations = {
  SET_LOADING (state, loading) {
    state.loading = loading
  },
  SET_DATA (state, payload) {
    state.data = payload
    state.lastFetchedAt = new Date().toISOString()
  },
  SET_COMPANY_ID (state, id) {
    state.lastCompanyId = id
  },
  RESET (state) {
    state.data = null
    state.lastCompanyId = null
    state.lastFetchedAt = null
  }
}

const actions = {
  async fetchKpis ({ commit }, companyId) {
    if (!companyId) return { success: false, error: 'Company ID required' }

    commit('SET_LOADING', true)
    commit('SET_COMPANY_ID', companyId)

    try {
      const response = await api.get(`/kpis/${companyId}`)
      commit('SET_DATA', response.data)
      return { success: true, data: response.data }
    } catch (error) {
      const message = error.response?.data?.error || 'Failed to fetch KPIs'
      return { success: false, error: message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateConfig ({ dispatch }, { companyId, config }) {
    try {
      await api.put(`/kpis/${companyId}/config`, config)
      return dispatch('fetchKpis', companyId)
    } catch (error) {
      const message = error.response?.data?.error || 'Failed to update KPI config'
      return { success: false, error: message }
    }
  },

  reset ({ commit }) {
    commit('RESET')
  }
}

const getters = {
  data: state => state.data,
  loading: state => state.loading,
  kpis: state => state.data?.kpis || {},
  period: state => state.data?.period || null,
  config: state => state.data?.config || null,
  lastFetchedAt: state => state.lastFetchedAt
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
